/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/prefer-default-export */
import React from "react";
import { useSelector } from "react-redux";
import { Box, Grid } from "@material-ui/core";
import PageHeader from "../components/headerV2/PageHeader";
import { useSubheader } from "../../../_metronic/layout";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { HomeButton } from "../components/pageparts/HomeButton";
import { useIntl } from "../../../_metronic/i18n/customUseIntl";
import featureFlags from "../utils/featureFlags";
import { useWarmupFpPerformance } from "../hooks/useWarmupFpPerformance";
import { Spacer } from "../components/helpers/Spacer";

const myFarms = toAbsoluteUrl("/media/sustell_15/bkgs/Farm_Bckgrnd_1.png");
const myFarmsIcon = toAbsoluteUrl(
  "/media/sustell_15/section_icons/my_farms.svg",
);
const myFeeds = toAbsoluteUrl("/media/sustell_15/bkgs/Feed_Bckgrnd_1.png");
const myFeedsIcon = toAbsoluteUrl(
  "/media/sustell_15/section_icons/my_feeds.svg",
);
const myIngredients = toAbsoluteUrl(
  "/media/sustell_15/bkgs/Ingredient_Bckgrnd_1.png",
);
const myIngredientsIcon = toAbsoluteUrl(
  "/media/sustell_15/section_icons/my_ingredients.svg",
);

export const SustellHomePage = (props) => {
  const intl = useIntl();
  const subheader = useSubheader();
  subheader.setTitle(intl.formatMessage({ id: "SUBHEADER.HOME" }));
  const selectedCustomer = useSelector(
    (state) => state.selectedCustomer?.value,
  );

  useWarmupFpPerformance();

  const myFeedsHref = featureFlags.feedV2Routing
    ? `/v2/feeds?customerId=${selectedCustomer.id}`
    : `/customers/${selectedCustomer.id}/myfeeds`;

  const myFarmsHref = featureFlags.farmV2Routing
    ? `/v2/farms?organizationId=${selectedCustomer.id}`
    : `/customers/${selectedCustomer.id}/myfarms`;

  const tileSize = 4;

  return (
    <>
      <PageHeader
        title={intl.formatMessage({
          id: "SUBHEADER.HOME",
        })}
        description={intl.formatMessage({
          id: "SUBHEADER.CONTENT",
        })}
        horizontalRule
      />

      <Spacer height="48px" />
      <Grid container spacing={4} justifyContent="center">
        <Grid item md={tileSize} style={{ maxWidth: "416px" }}>
          <HomeButton
            bkgImg={myIngredients}
            icon={myIngredientsIcon}
            title={intl.formatMessage({ id: "SUSTELL.MY_INGREDIENTS" })}
            intro={intl.formatMessage({ id: "SUSTELL.MY_INGREDIENTS.INTRO" })}
            applyGradientOverlay
            href={`/v2/ingredients?organizationId=${selectedCustomer.id}`}
          />
        </Grid>
        <Grid item md={tileSize} style={{ maxWidth: "416px" }}>
          <HomeButton
            bkgImg={myFeeds}
            icon={myFeedsIcon}
            title={intl.formatMessage({ id: "SUSTELL.MY_FEEDS" })}
            intro={intl.formatMessage({ id: "SUSTELL.MY_FEEDS.INTRO" })}
            href={myFeedsHref}
          />
        </Grid>
        <Grid item md={tileSize} style={{ maxWidth: "416px" }}>
          <HomeButton
            bkgImg={myFarms}
            icon={myFarmsIcon}
            title={intl.formatMessage({ id: "SUSTELL.MY_FARMS" })}
            intro={intl.formatMessage({ id: "SUSTELL.MY_FARMS.INTRO" })}
            href={myFarmsHref}
          />
        </Grid>
      </Grid>
    </>
  );
};
